"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.createWorkspace = graphql_tag_1.default `
  mutation createWorkspace($data: WorkspaceCreateInput!) {
    createWorkspace(data: $data){
      id
      name
    }
  }
`;
exports.updateWorkspace = graphql_tag_1.default `
mutation updateWorkspace($id: ID!, $data: WorkspaceUpdateInput!) {
  updateWorkspace(id: $id, data: $data) {
      id
      name
      dashboardUrls
    }
  }
`;
exports.addPaymentSource = graphql_tag_1.default `
  mutation addPaymentSource($id: String!, $data: WorkspacePaymentSourceInput!) {
    addPaymentSource(id: $id, data: $data) {
      accountNumberForACH
      routingNumberForACH
    }
  }
`;
//# sourceMappingURL=workspaces.js.map